export const defaultState = () => {
  return {
    currentLayout: "",
    articleSearch: {
      searchTitle: "",
      searchDesc: "",
      limit: 10,
      searchResult: {
        articles: [],
        total: 0
      }
    },
    categorySearch: {
      playList: [],
      video: {
        id:"",
        key:""
      }
    },
    isApiCalling: false,
    isShowModal: false,
    isShowIcon: false,
    momentOpen: Date,
    momentClose: Date
  };
};

const state = defaultState();

export default state;
